// ─────────────────────────────────────────────────────────────────
// Notification Filter — Matches Xamarin AppConstants
// ─────────────────────────────────────────────────────────────────

export const NOTIFICATION_FILTER = {
  ALL: 'All',
  TASK: 'Task',
  TRAILER: 'Trailer',
} as const;

export type NotificationFilterType = (typeof NOTIFICATION_FILTER)[keyof typeof NOTIFICATION_FILTER];

// Matches Xamarin AppConstants
const NOTIFICATION_ACTION = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

// Matches Xamarin NotificationActionCodeToTextConverter
// Returns i18n key for the action code — caller must pass through t()
export function actionCodeToKey(actionCode: string): string {
  const upper = actionCode.toUpperCase();
  if (upper === NOTIFICATION_ACTION.CREATE) return 'notification.taskCreated';
  if (upper === NOTIFICATION_ACTION.DELETE) return 'notification.taskCancelled';
  if (upper === NOTIFICATION_ACTION.UPDATE) return 'notification.taskUpdated';
  return '';
}
